// LocationSelector — Presentational toggle between "Near Airport" and
// "Near Hotel" shown after a search has been performed.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// and text are identical to the source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { locationSelectorButtonStyle } from './styles';

export const LocationSelector = React.memo(function LocationSelector({ searchLocation, setSearchLocation, location, selectedHotel }) {
  return (
    <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
      <button
        onClick={() => setSearchLocation('airport')}
        style={locationSelectorButtonStyle(searchLocation === 'airport')}
      >
        ✈️ Near Airport ({location?.airportCode})
      </button>
      <button
        onClick={() => setSearchLocation('hotel')}
        style={locationSelectorButtonStyle(searchLocation === 'hotel')}
      >
        🏨 Near Hotel ({selectedHotel?.name})
      </button>
    </div>
  );
});

export default LocationSelector;
